// hooks/useAtualizarDados.ts
import { useState } from "react";
import { atualizarInfoPagamento } from "../../../services/atualizarInfoPagamentoService";

export const useAtualizarInfoPag = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const atualizar = async (values: any) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const infoPag = await atualizarInfoPagamento(values);
      if (infoPag) {
        setSuccess("Chave pix atualizada com sucesso!");
      } else {
        setError("Não foi possível atualizar chave pix. Tente Novamente!");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return { atualizar, isLoading, isSuccess, error, success };
};
